module.exports = __webpack_public_path__ + "static/media/steidle.d6e676ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/steidle.png
// module id = 463
// module chunks = 0